import React from "react";
import { useAuth } from "../context/AuthContext";
import { useRoutes, Navigate } from "react-router-dom";

import LoginPage from "../components/authentication/LoginPage";
import SignupPage from "../components/authentication/SignupPage";
import ResetPasswordPage from "../components/authentication/ResetPasswordPage";
import GoogleAuthCallback from "../components/authentication/google/GoogleAuthCallback";
import GoogleRedirectBridge from "../components/authentication/google/GoogleRedirectBridge";
import PrivateLayout from "../components/layout/PrivateLayout";
import Dashboard from "../components/dashboard/Dashboard";
import LandingPage from "../components/landing/LandingPage";
import MarketCyclesPage from "../components/pages/market/MarketCyclesPage";
import MembershipPage from "../components/membership/MembershipPage";
import RealEstateIndicatorsPage from "../components/pages/realestate/RealEstateIndicatorsPage";
import EconomicIndicatorsPage from "../components/pages/economic/EconomicIndicatorsPage";
import InsightSuburbsPage from "../components/pages/topsuburbs/InsightSuburbsPage";
import SuburbsIndicatorsPage from "../components/pages/topsuburbs/SuburbsIndicatorsPage";
import AccountPage from "../components/account/AccountPage";

import DashboardLayout from "../features/dashboards/layouts/DashboardLayout";
import { dashboardRoutes } from "../features/dashboards/config/dashboardRoutes";

const withIndex = (routes) => [
  { index: true, element: <Navigate to={routes[0].path} replace /> },
  ...routes,
];

export default function AppRoutes() {
  const { user } = useAuth();
  const isAdmin = String(user?.role || "").toUpperCase() === "ADMIN";
  const element = useRoutes([
    // Public
    { path: "/login", element: <LoginPage /> },
    { path: "/signup", element: <SignupPage /> },
    { path: "/reset-password", element: <ResetPasswordPage /> },
    { path: "/google-auth", element: <GoogleAuthCallback /> },
    { path: "/google/callback", element: <GoogleRedirectBridge /> },
    { path: "/membership", element: <MembershipPage /> },

    // Private
    {
      element: <PrivateLayout />,
      children: [
        { path: "/dashboard", element: <Dashboard /> },
        { path: "/market/states", element: <MarketCyclesPage level="State" title="States" /> },
        { path: "/market/cities", element: <MarketCyclesPage level="City" title="Capital cities" /> },
        { path: "/real-state-indicators", element: <RealEstateIndicatorsPage /> },
        { path: "/economic-indicators", element: <EconomicIndicatorsPage /> },
        { path: "/top-suburbs/insight", element: <InsightSuburbsPage /> },
        { path: "/top-suburbs/indicators", element: <SuburbsIndicatorsPage /> },
        { path: "/account", element: <AccountPage /> },

        ...(isAdmin ? [{
          path: "/dashboards",
          element: <DashboardLayout title="Administration" />,
          children: withIndex(dashboardRoutes),
        }] : []),
      ],
    },

    // Fallbacks
    { path: "/", element: <LandingPage /> },
    { path: "*", element: <LandingPage /> },
  ]);

  return element;
}
